module.exports = __webpack_public_path__ + "static/img/registration.c0116af9.png";